import React from 'react'
import {
    Typography,
    createStyles,
    makeStyles,
    Tooltip
} from "@material-ui/core"
import InfoIcon from '@material-ui/icons/Info';


const useStyles = makeStyles((theme) =>
  createStyles({
    topLeft: {
        fontFamily: "Brown-Bold",
        fontSize: "17px",
        textAlign: "start",
        color: "#ffffff",
    },

    bottomLeft: {
        opacity: 0.54,
        fontFamily: "Brown-Bold",
        fontSize: "10px",
        textAlign: "start",
        color: "#ffffff",
    },

    topRightPositive: {
        fontFamily: "Brown-Bold",
        fontSize: "18px",
        textAlign: "end",
        color: "#00e600",
    },

    topRightNegative: {
        fontFamily: "Brown-Bold",
        fontSize: "18px",
        textAlign: "end",
        color: "#ff0000",
    },

    infoIcon: {
        position:"absolute",
        left:"1px",
        top:"1px",
        fontSize:"18px"

    },
    
    toolTip: {
        

    },

  })
)

const TopSection = (props)=>{
    const classes = useStyles();
    const{
        data:{
            topRight="",
            topLeft="",
            bottomLeft=""
        }={}
    }=props
    const isPositive = (formatedNumber)=>{
        return formatedNumber.replace("₹","").replace(/,/g, '') >= 0
    }
    return (
        <div
        style={{
            display: "flex",
            marginLeft: "1px",
            marginRight: "1px",
            marginBottom: "12px",
            padding: "15px",
            backgroundColor: "#454540",
            borderRadius: "15px",
            color: "white",
            width: "100%",
            position:"relative",
          }}
        >
            <div style={{ display: "flex",flex: 2, flexDirection: "column", position:"relative" }}>
                <div>
                <Typography variant="body1" className={classes.topLeft}>
                    {topLeft}
                </Typography>
                {bottomLeft ? <Typography variant="body1" className={classes.bottomLeft}>
                    {bottomLeft}
                </Typography> : null}
                </div>
            </div>
            <div style={{ flex: 1 }}>
                {/* {title2 != null ? ( */}
                    <Typography variant="body1" className={isPositive(topRight) ? classes.topRightPositive : classes.topRightNegative}>
                        {topRight}
                    </Typography>
                {/* ) : null} */}
                {/* {title3 != null ? ( */}
                    {/* <Typography variant="body1" className={classes.headerTitle3}>
                    "Title 3"
                </Typography> */}
                {/* ) : null} */}
            </div>
            <Tooltip title="This data pertains to FY20-21 and beyond." 
                classes={{tooltip: classes.toolTip}} 
                placement="top-end" 
                arrow 
                interactive >
                <InfoIcon className={classes.infoIcon}  />
            </Tooltip>
        </div>
    )
}

export default TopSection